import _ from 'underscore';
import GameStarterModel from './game-starter-model';
import UserGameStatusModel from './user-game-status-model';
import launch from './launch';
import { sendOSInfo } from './send-os-info';

var userGameStatus = new UserGameStatusModel();

var gameStarter = new GameStarterModel({ id: 'gameStarter' });

_.extend(gameStarter, {
  launch: launch,
  sendOSInfo: sendOSInfo
});

export { userGameStatus };

export { gameStarter };

export {
  checkAXInstalled,
  checkAXUpdateNeeded,
  checkPmangStarterInstalled,
  tryUpdateAX
} from './launch';

export { redirectToInstallAX } from './redirect-to-install-ax';
